/* eslint-disable */
export default {
  inAMeeting: 'Numa reunião',
  onMyWay: 'Estou a caminho',
  callMeBackIn: 'Volte a ligar-me dentro de...',
  willCallYouBackIn: 'Ligarei de volta dentro de...',
  hour: 'hora',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
